const carRental = {
  carRental: "Automobilių nuoma", // translated 
  carRentals: "Automobilių nuoma", // translated 
  pickUpPoint: "Paėmimo taškas", // translated 
  dropOffPoint: "Išleidimo taškas", // translated 
  pickUpDate: "Paėmimo data", // translated 
  dropOffDate: "Išleidimo data", // translated 
  pickUp: "Paimti", // translated 
  dropOff: "Išmesti", // translated 
  edit: "Redaguoti", // translated 
  fuelPolicy: "Kuro politika", // translated 
  pickUpLocation: "Paėmimo vieta", // translated 
  mileage: "Rida", // translated 
  transmission: "Užkrato pernešimas", // translated 
  airCondition: "Oro kondicionavimas", // translated 
  minimumAge: "Minimalus amžius", // translated 
  maximumAge: "Maksimalus amžius", // translated 
  providerAddress: "Teikėjo adresas", // translated 
  providerPhone: "Tiekėjo telefonas", // translated 
  driverInfo: "Vairuotojo informacija", // translated 
  driversInfo: "Vairuotojo informacija", // translated 
  differentDropOff: "Išleidimas į kitą vietą", // translated 
  maxPassengers: "Maksimalus keleivių skaičius", // translated 
  budget: "Biudžetas", // translated 
  provider: "Teikėjas", // translated 
  carModel: "Automobilio modelis", // translated 
  numOfDoors: "Durų skaičius", // translated 
  fuelType: "Kuro tipas", // translated 
  driverAge: "Vairuotojo amžius", // translated 
  workingHours: "Darbo valandos", // translated 
  driverNationality: "Vairuotojo pilietybė", // translated 
  carRentalRate: "Automobilių nuomos kaina", // translated 
  dueNow: "Terminas dabar", // translated 
  duePickUp: "Terminas atsiėmimo metu", // translated 
  toViewOfferPDF:
    "Norėdami peržiūrėti PDF dokumentą su visomis šio pasiūlymo nuomos sąlygomis, prašome", // translated 
  toViewTermsAndCondPDF:
    "Norėdami peržiūrėti taikomas CARNECT taisykles ir sąlygas, prašome", // translated 
};


export default carRental;
